import { IUserSortByOptions } from '@/content/components/pages/UserManagement/types';
import { getLicenseLabel } from '@/utils/helpers/userManagementHelper';
import { LICENSE_TYPE } from '@/consts/common';
import { LICENSE_PRODUCT } from '@/consts/licenseManagement';
import { ISelectField } from '@/content/components/common/Select';
import { ILicense, ILicenseType } from '@/services/licenses/types';

export const UNLICENSED_LICENSE_STUB: ILicense = {
  licenseUuid: 'unlicensed-stub',
  user: {
    userUuid: '',
    title: '',
    firstName: '',
    lastName: '',
    email: '',
  },
  userUuid: '',
  orgUuid: '',
  product: LICENSE_PRODUCT.HOLOXR,
  licenseType: LICENSE_TYPE.UNLICENSED,
  status: 'AVAILABLE',
  expiresAt: '',
  assignedBy: '',
  assignedAt: '',
  createdAt: '',
  updatedAt: '',
};

export const createLicenseChipStub = (licenseType: ILicenseType): ILicense => ({
  licenseUuid: `license-chip-stub-${licenseType}`,
  userUuid: '',
  orgUuid: '',
  product: LICENSE_PRODUCT.HOLOXR,
  licenseType,
  status: 'AVAILABLE',
  expiresAt: '',
  assignedBy: '',
  assignedAt: '',
  createdAt: '',
  updatedAt: '',
  user: {
    userUuid: '',
    title: '',
    firstName: '',
    lastName: '',
    email: '',
  },
});

export const USER_MANAGEMENT_FILTER_OPTIONS: ISelectField<ILicenseType>[] = [
  { id: 'all', name: 'All' },
  ...Object.values(LICENSE_TYPE).map((licenseType) => ({
    id: licenseType,
    name: getLicenseLabel(licenseType)!,
  })),
] as const;

export const USER_MANAGEMENT_SORT_BY_OPTIONS: IUserSortByOptions[] = [
  {
    id: 'createdAt',
    name: 'Created at',
  },
];

export const MOBLE_MAX_WIDTH_SIZE = 900;

export const USER_MANAGEMENT_MODE = {
  SELF_ORG_USERS: 'selfOrgUsers',
  INDEPENDENT_USERS: 'independentUsers',
  ORG_SPECIFIC_USERS: 'orgSpecificUsers',
} as const;

export type IUserManagementMode =
  (typeof USER_MANAGEMENT_MODE)[keyof typeof USER_MANAGEMENT_MODE];
